import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    Typography,
    Form,
    message,
    Modal,
    Input,
    InputNumber,
    setParamsFilter,
    Select,
    Switch,
    Textarea,
    Radio,
    ExpandableText
} from "../../../ui/ot";
import { useCRUDController } from "../../../ui/classify_structure/CRUDController"
import { useTranslation } from "react-i18next";
import { ManageMARCRecordTable } from '../BackStage/ManageMARCRecord'
import { useNavigate, useSearchParams } from "react-router-dom";
import { PreviewCodeFormItemComponent } from '../BackStage/serial_code_management'
const SerialsManagement = (
    permission_level = null, 
) => {

    return (
        <Row>
            <Col span={24}>
                <SerialsManagementTable keyPrefix={'cataloging.serials_management'} permission_level={permission_level} />
            </Col>
        </Row>
    )
}
const SerialsManagementTable = ({
    keyPrefix = 'cataloging.serials_management',
    propsSubscriptionid,
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef(null);
    const navigate = useNavigate();

    const columns = [
        {
            title: t('vendor'),
            dataIndex: "aqbookseller_name",
            key: "aqbookseller_name",
        },
        {
            title: t('bibTitle'),
            dataIndex: "title",
            key: "title",
            width: 300,
            render: (text, record, index) => {
                return (<ExpandableText maxLines={1} text={text} />)
            }
        },
        {
            title: t('received_serial_number'),
            dataIndex: "serialsadditems",
            key: "serialsadditems",
            render: (text, record, index) => {
                if (!!record?.serialsadditems) {
                    return (<>{t('create_new_item')}</>)
                }
                else {
                    return (<>{t('do_not_create_new_item')}</>)

                }
            }
        },
        {
            title: t('irregular_issue'),
            dataIndex: "skip_serialseq",
            key: "skip_serialseq",
            render: (text, record, index) => {
                if (!!record?.serialsadditems) {
                    return (<>{t('skip_issue_number')}</>)
                }
                else {
                    return (<>{t('keep_issue_number')}</>)

                }
            }
        },
        {
            title: t('manual_record_change'),
            dataIndex: "manualhistory",
            key: "manualhistory",
            render: (text, record, index) => {
                if (!!record?.manualhistory) {
                    return (<Row justify="center">
                        <Col>
                            <Typography.P>
                                {t('yes')}
                            </Typography.P>
                        </Col>
                    </Row>)
                }
                else {
                    return (<Row justify="center">
                        <Col>
                            <Typography.P>
                                {t('no')}
                            </Typography.P>
                        </Col>
                    </Row>)

                }
            }
        },
        {
            title: t('call_number'),
            dataIndex: "callnumber",
            key: "callnumber",
        },
        {
            title: t('library'),
            dataIndex: "branchcode",
            key: "branchcode",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {text} {record?.branchname}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        {
            title: t('public_note'),
            dataIndex: "notes",
            key: "notes",
        },
        {
            title: t('internal_note'),
            dataIndex: "internalnotes",
            key: "internalnotes",
        },
        // {
        //     title: t('subscriber_notification'),
        //     dataIndex: "letter",
        //     key: "letter",
        // },
        {
            title: t('shelving_location'),
            dataIndex: "location",
            key: "location",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {text} {record?.locationname}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        {
            title: `${t('grace_period') + t('day')}`,
            dataIndex: "graceperiod",
            key: "graceperiod",
        },
        {
            title: t('first_issue_publication_date'),
            dataIndex: "firstacquidate",
            key: "firstacquidate",
        },
        {
            title: t('frequency'),
            dataIndex: "frequency",
            key: "frequency",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {record?.frequency_name}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        {
            title: t('subscription_length'),
            dataIndex: "subtype",
            key: "subtype",
            render: (text, record, index) => {
                return <Typography.P>{record?.sublength} {t(record?.subtype)}</Typography.P>
            }
        },
        {
            title: t('subscription_start_date'),
            dataIndex: "startdate",
            key: "startdate",
        },
        {
            title: t('subscription_end_date'),
            dataIndex: "enddate",
            key: "enddate",
        },
        {
            title: t('numbering_pattern'),
            dataIndex: "numbering_pattern",
            key: "numbering_pattern",
            render: (text, record, index) => {
                return (<Row justify="center">
                    <Col>
                        <Typography.P>
                            {record?.subscription_numberpatterns_label}
                        </Typography.P>
                    </Col>
                </Row>)
            }
        },
        // {
        //     title: t('publication_date_template'),
        //     dataIndex: "published_on_template",
        //     key: "published_on_template",
        // },

    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [axiosMode, setAxiosMode] = useState("get");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.customer_service_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.customer_service_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.customer_service_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.customer_service_id
                );
                selectRow = selectRow.filter(
                    (row) => row.customer_service_id !== record.customer_service_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };

    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    };
    const {
        getData,
        postData,
        patchData,
        deleteData,
        ResponseData,
    } = useCRUDController({
        apiRoute: "/koha/serial",
        onFinish,
        onBefore,
    });
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const locController = useCRUDController({ apiRoute: "/koha/authorised_values" })
    const vendorController = useCRUDController({ apiRoute: "/koha/vendor" })
    const numberingpatternController = useCRUDController({ apiRoute: "/koha/serial/numberingpattern" })

    useEffect(() => {
        checkAll();
        libraryController.getData({})
        locController.getData({ category: "LOC" })
        vendorController.getData({})
        numberingpatternController.getData({})
    }, []);

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <ProTableOt
                    formMode={true}
                    rowKey={"subscriptionid"}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return getData({
                            ...newParams,
                        });
                    }}
                    toolBarRender={() => {
                        return [
                        ];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: selectedRowsInfo,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}
                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<SerialsManagementForm
                        venderOptions={vendorController?.ResponseData}
                        libraryOptions={libraryController?.ResponseData}
                        locOptions={locController?.ResponseData}
                        numberingpatternOptions={numberingpatternController?.ResponseData}
                    />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        letter: null,
                                        aqbooksellerid: val?.aqbooksellerid,
                                        "innerlooptemp1": val?.innerloop1,
                                        "innerlooptemp2": val?.innerloop2,
                                        "innerlooptemp3": val?.innerloop3,
                                        "lastvaluetemp1": val?.lastvalue1,
                                        "lastvaluetemp2": val?.lastvalue2,
                                        "lastvaluetemp3": val?.lastvalue3,
                                    }
                                })
                                postData(newData)
                            },
                            patchData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        letter: null,
                                        aqbooksellerid: val?.aqbooksellerid,
                                        "innerlooptemp1": val?.innerloop1,
                                        "innerlooptemp2": val?.innerloop2,
                                        "innerlooptemp3": val?.innerloop3,
                                        "lastvaluetemp1": val?.lastvalue1,
                                        "lastvaluetemp2": val?.lastvalue2,
                                        "lastvaluetemp3": val?.lastvalue3,
                                    }
                                })
                                patchData(newData)
                            },
                            deleteData: (data) => {
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                deleteData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={permission_level?.permission_level === 1 ? true : false}
                    propsPatchProcess={(record) => {
                        // let newRecord = transformData(record)
                        return { ...record }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={permission_level?.permission_level === 1 ? true : false}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}
                    extraActionRender={(record) => {
                        return permission_level?.permission_level === 1 ? 
                        <Button onClick={() => {
                            navigate(`../serial_receive?subscriptionid=${record?.subscriptionid}`)
                        }}>
                            {t('receive_serial')}
                        </Button>
                        : <></>
                    }}
                    propsPost={permission_level?.permission_level === 1 ? true : false}
                    propsPostOnBefore
                    initialValues={{}}
                    propsWidth={1800}

                />
            </Col>
        </Row>
    );
};

const SerialsManagementForm = (
    {
        keyPrefix = 'cataloging.serials_management',
        propsForm,
        field,
        initialValues,
        defaultValue,
        onFormFinish = () => { },
        propsOnValuesChange = () => { },
        venderOptions,
        libraryOptions,
        locOptions,
        locMenuPortalTarget,
        frequencyOptions,
        numberingpatternOptions

    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_

    const { t } = useTranslation('translation', { keyPrefix })
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        let changeValue = form.getFieldValue(name)
        let nameSplit = name.split(".")

        if (nameSplit.includes("numbering_pattern")) {
            nameSplit = nameSplit.slice(0, -1);
            if (nameSplit.length > 1) {
                let newName = nameSplit.join('.')
                let thisValues = form.getFieldValue(newName)
                console.log({
                    thisValues,
                    numberingpatternOptions,
                })
                let selectedNumberingpatternValues = (numberingpatternOptions || [])?.find((ele) => ele?.id === changeValue)

                if (selectedNumberingpatternValues) {
                    delete selectedNumberingpatternValues.id
                }
                selectedNumberingpatternValues = {
                    ...selectedNumberingpatternValues,

                    patternname: selectedNumberingpatternValues?.label,
                    //暫時
                    "ccode": null,
                    "irreg_check": 0,
                    "issuelengthcount": null,
                    "staffdisplaycount": null,
                    "itemtype": null,
                    "mana_id": null,
                    "published_on_template": null,
                }

                let finalValues = {
                    ...thisValues,
                    ...selectedNumberingpatternValues
                }

                form.setFieldValue(newName, finalValues)
            }
            else {
                let newName = nameSplit.join('.')
            }
        }

    };
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const locController = useCRUDController({ apiRoute: "/koha/authorised_values" })
    const vendorController = useCRUDController({ apiRoute: "/koha/vendor" })
    const frequencyController = useCRUDController({ apiRoute: "/koha/serial/periodicity" });
    const numberingpatternController = useCRUDController({ apiRoute: "/koha/serial/numberingpattern" })
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        if (!libraryOptions) {
            libraryController.getData({})
        }
        if (!locOptions) {
            locController.getData({
                category: "LOC",
            })
        }
        if (!venderOptions) {
            vendorController.getData({})
        }
        if (!frequencyOptions) {
            frequencyController.getData({})
        }
        if (!numberingpatternOptions) {
            numberingpatternController.getData({})
        }
    }, [])
    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                                form={form}
                                libraryOptions={libraryOptions ? libraryOptions : libraryController?.ResponseData}
                                locOptions={locOptions ? locOptions : locController?.ResponseData}
                                locMenuPortalTarget={locMenuPortalTarget}
                                venderOptions={venderOptions ? venderOptions : vendorController?.ResponseData}
                                numberingpatternOptions={numberingpatternOptions ?? numberingpatternController?.ResponseData}
                                frequencyOptions={frequencyOptions ?? frequencyController.ResponseData}
                            />
                        </Col>

                    </Row>
                </Form>
            </Col>
        </Row>
    );

}
const FormItemComponent = ({
    form,
    keyPrefix,
    field,
    initialValues = {},
    libraryOptions = [],
    locOptions = [],
    locMenuPortalTarget,
    venderOptions = [],
    numberingpatternOptions = [],
    frequencyOptions = []
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={3}
                            {...field}
                            name={[field?.name ?? '', 'biblionumber']}
                            fieldKey={[field?.fieldKey ?? '', 'biblionumber'].join('.')}
                            hidden={true}
                        >
                            <div></div>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'itemnumber']}
                            fieldKey={[field?.fieldKey ?? '', 'itemnumber'].join('.')}
                            hidden={true}

                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`vendor`)}
                            name={[field?.name ?? '', 'aqbooksellerid']}
                            fieldKey={[field?.fieldKey ?? '', 'aqbooksellerid'].join('.')}
                        >
                            <Select
                                options={venderOptions.map((value) => {
                                    return {
                                        label: value?.name,
                                        value: value?.id
                                    }
                                })}

                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} >
                                <Form.Item
                                    {...field}
                                    label={t(`biblionumber`)}
                                    name={[field?.name ?? '', 'biblionumber']}
                                    fieldKey={[field?.fieldKey ?? '', 'biblionumber'].join('.')}
                                    labelCol={12}
                                    wrapperCol={12}
                                    disabled={true}
                                    rules={[{ required: true, message: t('please_input_item') }]}

                                >
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                <Form.Item
                                    {...field}
                                    label={t(`bibliographic_title`)}
                                    name={[field?.name ?? '', 'title']}
                                    fieldKey={[field?.fieldKey ?? '', 'title'].join('.')}
                                    disabled={true}
                                >
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <BiblionumberModal
                                    title={t('select_bibliographic')}
                                    openButtonText={t('select_bibliographic')}
                                    propsHandleOk={(selectRow) => {
                                        let title = selectRow?.bib_title
                                        let biblionumber = selectRow?.bib_biblionumber
                                        form.setFieldValue([field?.name ?? '', 'title'].join('.'), title)
                                        form.setFieldValue([field?.name ?? '', 'biblionumber'].join('.'), biblionumber)
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`received_serial_number`)}
                            name={[field?.name ?? '', 'serialsadditems']}
                            fieldKey={[field?.fieldKey ?? '', 'serialsadditems'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Radio.Group>
                                <Radio value={1}>
                                    {t('create_item_record')}
                                </Radio>
                                <Radio value={0}>
                                    {t('do_not_create_item_record')}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`irregular_issue`)}
                            name={[field?.name ?? '', 'skip_serialseq']}
                            fieldKey={[field?.fieldKey ?? '', 'skip_serialseq'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Radio.Group>
                                <Radio value={1}>
                                    {t('skip_issue_number')}

                                </Radio>
                                <Radio value={0}>
                                    {t('keep_issue_number')}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`manual_record_change`)}
                            name={[field?.name ?? '', 'manualhistory']}
                            fieldKey={[field?.fieldKey ?? '', 'manualhistory'].join('.')}
                        >
                            <Switch
                                checkedChildren={t('yes')}
                                unCheckedChildren={t('no')}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`call_number`)}
                            name={[field?.name ?? '', 'callnumber']}
                            fieldKey={[field?.fieldKey ?? '', 'callnumber'].join('.')}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`library`)}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode'].join('.')}
                        >
                            <Select options={libraryOptions.map((option) => {
                                if (!!option?.label) {
                                    return {
                                        ...option
                                    }
                                }
                                else {
                                    return {
                                        label: option?.branchname,
                                        value: option?.branchcode,
                                    }
                                }
                            })} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`public_note`)}
                            name={[field?.name ?? '', 'notes']}
                            fieldKey={[field?.fieldKey ?? '', 'notes'].join('.')}
                        >
                            <Textarea />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`internal_note`)}
                            name={[field?.name ?? '', 'internalnotes']}
                            fieldKey={[field?.fieldKey ?? '', 'internalnotes'].join('.')}
                        >
                            <Textarea />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`subscriber_notification`)}
                            name={[field?.name ?? '', 'letter']}
                            fieldKey={[field?.fieldKey ?? '', 'letter'].join('.')}
                            hidden={true}
                        >
                            <Select options={[]} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`shelving_location`)}
                            name={[field?.name ?? '', 'location']}
                            fieldKey={[field?.fieldKey ?? '', 'location'].join('.')}
                        >
                            <Select menuPortalTarget={locMenuPortalTarget} options={locOptions.map((option) => {
                                if (!!option?.label) {
                                    return {
                                        ...option
                                    }
                                }
                                else {
                                    return {
                                        label: option?.description,
                                        value: option?.authorised_value,
                                    }
                                }
                            })} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`grace_period`) + `(${t(`day`)})`}
                            name={[field?.name ?? '', 'graceperiod']}
                            fieldKey={[field?.fieldKey ?? '', 'graceperiod'].join('.')}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`subscription_start_date`)}
                            name={[field?.name ?? '', 'startdate']}
                            fieldKey={[field?.fieldKey ?? '', 'startdate'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Input type={'date'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`subscription_end_date`)}
                            name={[field?.name ?? '', 'enddate']}
                            fieldKey={[field?.fieldKey ?? '', 'enddate'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Input type={'date'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`numbering_pattern`)}
                            name={[field?.name ?? '', 'numbering_pattern']}
                            fieldKey={[field?.fieldKey ?? '', 'numbering_pattern'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Select
                                options={numberingpatternOptions?.map((val) => {
                                    return {
                                        ...val,
                                        label: val?.label,
                                        value: val?.id
                                    }
                                })}
                            />

                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <PreviewCodeFormItemComponent
                            frequencyOptions={frequencyOptions}
                            //  keyPrefix={keyPrefix}
                            field={field}
                        />
                    </Col>
                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`publication_date_template`)}
                            name={[field?.name ?? '', 'published_on_template']}
                            fieldKey={[field?.fieldKey ?? '', 'published_on_template'].join('.')}
                            rules={[{ required: true, message: t('please_input_item') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col> */}
                </Row>
            </Col>
        </Row>
    );
};
const BiblionumberModal = ({
    propsOpen = null,
    propsLoading = null,
    openButtonText = "打開",
    propsSetOpen = () => { },
    propsHandleOk = () => { }
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null)
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
        propsHandleOk(selectRow)
        closeModal();

    };

    const handleCancel = () => {
        closeModal();
    };


    return (
        <Row>
            <Col>
                {propsOpen === null && (
                    <Button type="primary" onClick={showModal}>
                        {`${openButtonText}`}
                    </Button>
                )}
            </Col>
            <Col>
                <Modal
                    title={`${openButtonText}`}
                    open={propsOpen === null ? isModalOpen : propsOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    confirmLoading={propsLoading === null ? loading : propsLoading}
                    maskClosable={false}
                    width={1800}
                    contentStyle={{
                        padding: 16,
                    }}
                    okText={'儲存'}
                    cancelText={'取消'}
                >
                    <Row>
                        <Col span={24}>
                            <ManageMARCRecordTable
                                onSelectChange={(selectRows) => {
                                    let first = selectRows.find((ele) => true)
                                    setSelectRow(first)
                                }}
                            />
                        </Col>
                    </Row>
                </Modal>
            </Col>
        </Row>
    );
}
export default SerialsManagement
export { SerialsManagementTable, SerialsManagementForm }
